import { render, staticRenderFns } from "./ModalNotesEmail.vue?vue&type=template&id=ffceed8e&"
import script from "./ModalNotesEmail.vue?vue&type=script&lang=js&"
export * from "./ModalNotesEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports